/**
 * Spanish national and Andalucía regional holidays for 2027.
 *
 * SOURCE (official government only):
 *   - National + Andalucía: Decreto 84/2026, de 29 de abril, por el que se
 *     determina el calendario de fiestas laborales de la Comunidad Autónoma de
 *     Andalucía para el año 2027 (BOJA nº 84). Twelve fixed national/regional
 *     days; each municipality adds up to two local holidays.
 *
 * 2027 note: Día de Andalucía (28 Feb) and Asunción (15 Aug) fall on Sunday in
 * 2027 and are officially observed on the following Monday (1 Mar and 16 Aug).
 *
 * LOCAL (🔴) municipality holidays for 2027 are NOT yet included: the official
 * per-municipality resolution (BOJA) has not been published at time of writing.
 * They will be added from the official BOJA source once published — no dates are
 * guessed. Same structure as 2026 ({ date, scope, town, nameKey, name }).
 */

export const HOLIDAYS_2027 = [
  // ── National (🟡) ────────────────────────────────────────────────
  { date: '2027-01-01', scope: 'national',  nameKey: 'holidays.newYear',        name: 'New Year\u2019s Day' },
  { date: '2027-01-06', scope: 'national',  nameKey: 'holidays.epiphany',       name: 'Epiphany' },
  { date: '2027-03-25', scope: 'national',  nameKey: 'holidays.maundyThursday', name: 'Maundy Thursday' },
  { date: '2027-03-26', scope: 'national',  nameKey: 'holidays.goodFriday',     name: 'Good Friday' },
  { date: '2027-05-01', scope: 'national',  nameKey: 'holidays.labourDay',      name: 'Labour Day' },
  { date: '2027-08-16', scope: 'national',  nameKey: 'holidays.assumption',     name: 'Assumption of Mary (observed)' },
  { date: '2027-10-12', scope: 'national',  nameKey: 'holidays.nationalDay',    name: 'National Day of Spain' },
  { date: '2027-11-01', scope: 'national',  nameKey: 'holidays.allSaints',      name: 'All Saints\u2019 Day' },
  { date: '2027-12-06', scope: 'national',  nameKey: 'holidays.constitutionDay', name: 'Constitution Day' },
  { date: '2027-12-08', scope: 'national',  nameKey: 'holidays.immaculate',     name: 'Immaculate Conception' },
  { date: '2027-12-25', scope: 'national',  nameKey: 'holidays.christmas',      name: 'Christmas Day' },

  // ── Andalucía (🟢) ───────────────────────────────────────────────
  { date: '2027-03-01', scope: 'andalusia', nameKey: 'holidays.andalusiaDay',   name: 'Day of Andalucía (observed)' },

  // ── Local municipality (🔴) — pending official BOJA publication for 2027 ──
];
